import axios from 'axios';
import { adapterAfterLoginNavigate } from '@/microAdapt/function';
import { router } from '@/router';
import Message from '@/utils/resetMessage';
import { exitSystem } from "@/utils/generalMethods";
import logServeCof from '@/plugins/logServeCof.js';

// 创建axios实例
const service = axios.create({
    baseURL: `${window.serverUrl}/${logServeCof.logServeCof()}/project`,
    timeout: window.commonTimeout, // 请求超时时间
})

service.interceptors.response.use(response => {
    if (response.status == 200) {
        let data = response.data;
        // if (data.isSuccess) {
        //     return new Promise(resolve => { resolve(data) });
        // } else {
        //     Message.error({ message: data.errMsg });
        //     return new Promise((resolve, reject) => { return });
        // }
        return new Promise(resolve => { resolve(data) });
    }
}, err => {
    if (err.response.status == 504 || err.response.status == 404) {
        Message.error({ message: '服务器错误，请稍候再试!' });
    } else if (err.response.status == 403) {
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
            Message.error({ message: err.response.data.error.message });
        } else {
            Message.error({ message: '权限不足,请联系管理员!' });
        }
    } else if (err.response.status == 400) {
        if (err.response && err.response.data && err.response.data.error && err.response.data.error.details) {
            Message.error({ message: err.response.data.error.details });
        } else {
            Message.error({ message: '权限不足,请联系管理员!' });
        }
    } else if (err.response.status == 401) {
        Message({
            message: '登录信息已过期，请重新登录!',
            type: 'error',
            duration: 3 * 1000
        })
        adapterAfterLoginNavigate(() => {
            if (window.isCloseTab) {
                exitSystem();
            } else {
                if (window.isPrivate) {
                    router.push('/privateLogin');
                } else {
                    router.push('/login')
                }
                window.location.reload()
            }

        });
    } else {
        Message.error({ message: '未知错误!' });
    }
    return Promise.reject(err);
})

export default service;